@if (isAwpAgentEnabled()) {
  <rcom-chat-widget
    [attr.backend-api-base-url]="backendApiBaseUrl"
    [attr.locale]="locale"
    [attr.channel-data]="channelData"
    [attr.business-context]="businessContext"
    header-selector="app-header"
  ></rcom-chat-widget>
}
